export const pieData = [
    { name: "78.2%", value: 400 },
    { name: "28.2%", value: 200 },
    { name: "38.2%", value: 200 },
  ];